import React, { Component } from "react";
import Help from "./Help";
import GDTR from "./GDTR";

class Info extends Component {
  render() {
    return (
      <div className="col-xl-3 col-md-6 col-lg-4">
        <div className="card mb-3 bg-dark">
          <img className="card-img-top" src="./img/00.png" />

          <div className="card-body">
            <h4 className="card-title text-light">Smeden i Sund</h4>
            <h6 className="card-subtitle mt-2 mb-3 text-warning">Nettbutikk</h6>
            <div className="card-text mb-2 bg-dark text-light ">
              <small>
                <strong>Skulpturer smidd i jern.</strong> <br />
                Produktbildene er veiledende. <br />
                Unike, handgjorde eksemplarer.
                <br />
                Sikker kortbetalning via Vipps.
                <br />
                <br />
                <img className="btn-custom" src="./img/vipps_logo.svg" />
                {/* <a className="btn text-info" href="https://www.paypal.com/cgi-bin/webscr?cmd=_cart&business=QKRS3GKHU65ZS&display=1">
                  Vis handlekurven
                </a> */}
                <br />
                <br />
              </small>
              <Help />
              <GDTR />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Info;
